<template>

<div class="text" v-on:click="onClick($event)" v-tooltip="(canEdit) ? 'Click to edit' : false" :class="{'is-locked': !canEdit, 'is-preview': isPreview, 'is-rendered': isRendered, 'is-first': isFirst, 'is-last': isLast}">

	<template v-if="!isRendered">

		<app-icon v-if="!item.enabled && !isPreview" icon="show" v-tooltip="'Hidden'" class="text-lock" />
		<app-icon v-if="item.locked === 2 && item.enabled && !isPreview" icon="unlock" v-tooltip="'Locked'" class="text-lock" />
		<app-icon v-if="item.locked === 1 && item.enabled && !isPreview" icon="unlock" v-tooltip="'Edit only'" class="text-lock is-yellow" />

	</template>

	<app-text-title :is-first="isFirst" v-if="item.type === $constants.text.type.title" :item="item" />
	<app-text-tick v-if="item.type === $constants.text.type.tick" :item="item" />
	<app-text-cross v-if="item.type === $constants.text.type.cross" :item="item" />
	<app-text-check v-if="item.type === $constants.text.type.check" :item="item" />
	<app-text-checklist v-if="item.type === $constants.text.type.checklist" :item="item" />
	<app-text-star v-if="item.type === $constants.text.type.star" :item="item" />
	<app-text-location v-if="item.type === $constants.text.type.location" :item="item" />
	<app-text-pin v-if="item.type === $constants.text.type.pin" :item="item" />
	<app-text-link v-if="item.type === $constants.text.type.link" :item="item" />
	<app-text-group v-if="item.type === $constants.text.type.group" :item="item" />
	<app-text-image v-if="item.type === $constants.text.type.image" :item="item" />
	<app-text-text v-if="item.type === $constants.text.type.text" :item="item" />
	<app-text-embed v-if="item.type === $constants.text.type.embed" :item="item" />
	<app-text-phone v-if="item.type === $constants.text.type.phone" :item="item" />
	<app-text-thumb v-if="item.type === $constants.text.type.thumb" :item="item" />
	<app-text-trash v-if="item.type === $constants.text.type.trash" :item="item" />
	<app-text-stop v-if="item.type === $constants.text.type.stop" :item="item" />
	<app-text-lightbulb v-if="item.type === $constants.text.type.lightbulb" :item="item" />
	<app-text-address v-if="item.type === $constants.text.type.address" :item="item" />
	<app-text-email v-if="item.type === $constants.text.type.email" :item="item" />
	<app-text-hours v-if="item.type === $constants.text.type.hours" :item="item" />
	<app-text-connectedgroups v-if="item.type === $constants.text.type.connectedgroups" :item="item" />

	<div class="text-actions" v-if="!isPreview && !isRendered">

		<div class="text-actions-item is-green" v-if="!isAdmin && !item.locked && item.enabled" v-tooltip="'Currently showing<small>Click to hide</small>'" v-on:click="$emit('hide', item)"><app-icon icon="hide" /></div>
		<div class="text-actions-item is-red" v-if="!isAdmin && !item.locked && !item.enabled" v-tooltip="'Currently hidden<small>Click to show</small>'" v-on:click="$emit('show', item)"><app-icon icon="show" /></div>
		<div class="text-actions-item" v-tooltip="'Move block up'" v-if="!isFirst" v-on:click.stop="$emit('up', item)"><app-icon icon="move.up" /></div>
        <div class="text-actions-item" v-tooltip="'Move block down'" v-if="!isLast" v-on:click.stop="$emit('down', item)"><app-icon icon="move.down" /></div>
		<div class="text-actions-item" v-if="isAdmin || !item.locked" v-tooltip="'Remove block'" v-on:click.stop="$emit('remove', item)"><app-icon icon="remove" /></div>
    
    </div>

</div>

</template>

<script>

export default {

	props: ['item', 'index', 'route', 'isAdmin', 'isFirst', 'isLast', 'isRendered', 'isPreview'],

	computed: {

		canEdit: function() {

			return (this.isAdmin || this.item.locked < 2) && !this.isRendered

		}

	},

	methods: {

		onClick: function(e) {

			// address, link and email render a real anchor - never follow it from the editor
			if (e && e.preventDefault) e.preventDefault()

			if(!this.canEdit) return false

			this.$emit('click', this.item)

		}

	}

}

</script>

<style scoped>

.text {
	padding: 0px 20px;
	display: block;
	transition: transform 100ms linear;
}

.text:not(.is-rendered) {
	border-bottom: 1px solid #eee;
}

.text:not(.is-locked):not(.is-rendered) {
	cursor: pointer;
}

.text.is-preview {
	border: 2px solid #eee;
	border-radius: 10px;
}

.text.is-last:not(.is-preview) {
	border-bottom: 0px;
}

.text:not(.is-rendered):hover {
	border: 2px solid #4082d3!important;
	border-radius: 10px;
	margin-top: -2px;
	margin-left: -2px;
	display: flex;
	align-items: center;
	width: calc(100% + 2px);
	transform: scale(1.05);
	background-color: #fff;
	z-index: 2;
}

.text.is-preview {
	pointer-events: none;
}

.text.is-preview >>> .text-block {
	padding: 20px 0px 20px 0px;
	margin: 0px;
}

.text.is-first >>> .text-block {
	padding-top: 20px;
	margin-top: 0px;
}

.text.is-last >>> .text-block:last-child {
	padding-bottom: 20px;
}

.text.is-last >>> .location,
.text.is-preview >>> .location {
	padding-bottom: 0px;
}

.text-actions {
	position: absolute;
	right: 10px;
	top: 50%;
	transform: translateY(-50%);
	display: none;
	box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
	border-radius: 10px;
}

.text:hover .text-actions {
	display: flex;
}

.text-actions-item {
    border: 2px solid #eee;
    text-align: center;
	margin-left: -2px;
    line-height: 38px;
    height: 40px;
	background-color: #fff;
    width: 40px;
    font-size: 16px;
    cursor: pointer;
}

.text-actions-item:first-child {
	border-top-left-radius: 10px;
	border-bottom-left-radius: 10px;
	margin-left: 0px;
}

.text-actions-item:last-child {
	border-top-right-radius: 10px;
	border-bottom-right-radius: 10px;
}

.text-actions-item.is-green {
    border-color: #90c48b;
    color: #90c48b;
    z-index: 2;
}

.text-actions-item.is-red {
    border-color: #f75858;
    color: #f75858;
    z-index: 2;
}

.text-actions-item:hover {
	color: #fff;
	background-color: #4082d3;
    z-index: 3;
	border-color: #4082d3;
}

.text-lock {
	position: absolute;
	width: 24px;
	height: 24px;
	border-radius: 50%;
	background-color: #fff;
	border: 2px solid #eee;
	text-align: center;
	line-height: 22px;
	left: -12px;
	font-size: 12px;
	top: 50%;
	margin-top: -12px;
    border-color: #f75858;
    color: #f75858;
}

.text-lock.is-yellow {
    border-color: #f8d205;
    color: #f8d205;
}

</style>
